// Brand constants
export const NAAVI_LOGO = "/images/naavi-logo.png";
export const NAAVI_LOGO_LIGHT = "/images/naavi-logo-light.png";

export const NAV_LINKS = [
  { label: "Philosophy", href: "#philosophy" },
  { label: "Curriculum", href: "#curriculum" },
  { label: "Programs", href: "#programs" },
  { label: "Campus", href: "#campus" },
  { label: "Admissions", href: "#admissions" },
  { label: "Contact", href: "#contact" },
];

export const PROGRAMS = [
  {
    id: "toddlers",
    name: "Toddlers",
    age: "2 – 3 yrs",
    tagline: "First footprints into learning",
    blurb:
      "A gentle, sensory-rich introduction to school life. Guided by warmth, play and the rhythm of routine.",
    accent: "cornflower",
    image:
      "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/1ch10v45_20251104_111250.jpg",
  },
  {
    id: "nursery",
    name: "Early Years 1",
    age: "3 – 4 yrs",
    tagline: "Curiosity takes shape",
    blurb:
      "Purposeful play meets emerging literacy and numeracy, woven through stories, songs and hands-on discovery.",
    accent: "lime",
    image:
      "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/ynga1obl_e7540d4d-da86-46b6-937c-dea2aa6e2e43.jpg",
  },
  {
    id: "pre-k",
    name: "Early Years 2",
    age: "4 – 5 yrs",
    tagline: "Confident thinkers, joyful doers",
    blurb:
      "The Cambridge Early Years framework deepens — children lead projects, ask big questions and collaborate.",
    accent: "teal",
    image:
      "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/qpswuyme_IMG-20260313-WA0040.jpg",
  },
  {
    id: "kindergarten",
    name: "Early Years 3",
    age: "5 – 6 yrs",
    tagline: "Ready for the world, ready to lead",
    blurb:
      "A seamless bridge to primary school with rigour, creativity and character built in equal measure.",
    accent: "turquoise",
    image:
      "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/rmwwrf1m_IMG-20251203-WA0006.JPEG",
  },
];

export const CURRICULUM_PILLARS = [
  {
    title: "Communication & Language",
    desc: "Story, conversation and rich vocabulary — the foundation of every future thinker.",
    color: "cornflower",
  },
  {
    title: "Mathematical Thinking",
    desc: "Numbers, pattern and logic explored with manipulatives and everyday wonder.",
    color: "lime",
  },
  {
    title: "Physical Development",
    desc: "Fine and gross motor play — climbing, balancing, drawing, building.",
    color: "teal",
  },
  {
    title: "Creative Expression",
    desc: "Studio art, music, drama and messy play that honour the hundred languages of children.",
    color: "turquoise",
  },
  {
    title: "Personal, Social & Emotional",
    desc: "Kindness, self-regulation and the art of being in community.",
    color: "cornflower",
  },
  {
    title: "Understanding the World",
    desc: "Nature, culture, seasons and the global citizens children are already becoming.",
    color: "lime",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Naavi feels less like a school and more like a second home. Our daughter runs to the door every morning.",
    name: "Ananya & Rohan Mehta",
    role: "Parents, Nursery",
  },
  {
    quote:
      "The Cambridge approach is real here — teachers observe, listen and plan around the children. It's rare and remarkable.",
    name: "Dr. Sameera Iyer",
    role: "Parent, Pre-K",
  },
  {
    quote:
      "We toured eleven preschools. Naavi was the only one where we could feel the calm, the care and the craft.",
    name: "Farah & Daniel Okoye",
    role: "Parents, Kindergarten",
  },
];

export const ADMISSIONS_STEPS = [
  {
    step: "01",
    title: "Inquire",
    desc: "Share a few details about your little one and what you're looking for.",
  },
  {
    step: "02",
    title: "Visit the Campus",
    desc: "Walk our studios, gardens and reading nooks with a member of our team.",
  },
  {
    step: "03",
    title: "Parent Conversation",
    desc: "A warm, unhurried meeting to align on your child's journey with us.",
  },
  {
    step: "04",
    title: "Welcome to Naavi",
    desc: "Enrolment, onboarding and a gentle settling-in plan tailored to your child.",
  },
];

export const TIME_SLOTS = [
  "09:30 AM",
  "10:30 AM",
  "11:30 AM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
];

export const GALLERY_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/65lknuu8_IMG-20260313-WA0045.jpg",
    caption: "Dress-up day at Naavi",
    span: "col-span-2 row-span-2",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/rvlepfl7_IMG_ACC7EFD12CF0-1.JPEG",
    caption: "Football & outdoor play",
    span: "col-span-1 row-span-1",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/cx3elw29_PXL_20251015_044839924.JPEG",
    caption: "Chalkboard letters",
    span: "col-span-1 row-span-1",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/nns1ozg6_IMG-20251203-WA0006.JPEG",
    caption: "Group craft & colour play",
    span: "col-span-1 row-span-1",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/glzg6uim_4a543f9c-59db-4fae-a372-b890fb29a474.JPEG",
    caption: "Story time",
    span: "col-span-1 row-span-1",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/haclsa1h_IMG-20250807-WA0017.jpg",
    caption: "From farm to table",
    span: "col-span-2 row-span-1",
  },
];
